export function uiToRegistryAnswers(ui: Record<string, any>): Record<string, unknown> {
  const normalized: Record<string, unknown> = { ...ui };

  if (typeof ui['duesRequired'] === 'string') {
    normalized['duesRequired'] =
      ui['duesRequired'].trim().toLowerCase() === 'yes';
  }

  if (typeof ui['meetingFrequency'] === 'string') {
    normalized['meetingFrequency'] = ui['meetingFrequency'].trim();
  }

  if (ui['quorumExecMode'] && ui['quorumExecMode'] !== 'Specific number') {
    normalized['quorumExecNumber'] = null;
  }

  return normalized;
}
